import { Routes } from '@angular/router';

/**
 * Repair detail routes — single-page layout (no inner tabs).
 *
 * The page lives at the parent route. The legacy `/overview`, `/log` and
 * `/documents` sub-paths are kept as redirects so existing bookmarks and
 * notifications still resolve.
 */
export const repairDetailRoutes: Routes = [
  { path: '', pathMatch: 'full', children: [] },
  { path: 'overview', redirectTo: '', pathMatch: 'full' },
  { path: 'log', redirectTo: '', pathMatch: 'full' },
  { path: 'documents', redirectTo: '', pathMatch: 'full' }
];
